<ag-grid-angular
  [gridOptions]="gridOptions"
  [ensureDomOrder]="true"
  class="ag-theme-cdx"
></ag-grid-angular>
